export enum LocationStoreEvent {
  loadOneByIdStart = 'load-one-start',
  loadOneByIdSuccess = 'load-one-success',
  loadOneByIdFailure = 'load-one-failure',
  // TODO-FE[TPNX-2145] replace 'updated' with 'initialized'
  updated = 'updated',
}
